import Home from '@/pages/v1/Home'
import ProductAdd from '@/pages/v1/ProductAdd'
import OrderDetails from '@/pages/v1/OrderDetails'
import ProductSet from '@/pages/v1/ProductSet'
import PriceCheck from '@/pages/v1/PriceCheck'
import Reorder from '@/pages/v1/Reorder'
import OrderCreate from '@/pages/v1/OrderCreate'


export default [
  {
    path: '/app/',
    name: 'home',
    component: Home
  },
  {
    path: '/app/product/add',
    name: 'products_add',
    component: ProductAdd,
  },
  {
    path: '/app/order/details',
    name: 'order_details',
    component: OrderDetails,
  },
  {
    path: '/app/order/create',
    name: 'order_create',
    component: OrderCreate,
  },
  {
    path: '/app/product/set',
    name: 'product_set',
    component: ProductSet,
  },
  {
    path: '/app/reorder',
    name: 'reorder',
    component: Reorder,
  },
  {
    path: '/app/price/check',
    name: 'reorder',
    component: PriceCheck,
  }
]
